export enum ButtonSizeEnum {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}

export enum ButtonTypeEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Ghost = 'ghost',
  Gray = 'gray',
  Text = 'text',
}
